export function trimStringsOnObject(data: any, excludeKeys: string[]) {
    Object.keys(data).forEach(function (key) {
        if (typeof data[key] === 'string' && !excludeKeys.includes(key)) {
            let value: string = data[key] as string;
            data[key] = value.trim();
        }
    });
}